import React from 'react'
import styled from 'styled-components'

//const Button = styled.button`
//    display: none;
//    width: 100%;
 //   padding: 10px;
 //   background-color: ${({ theme }) => theme.white};
//    color: ${({ theme }) => theme.text_black};
//    font-size: 14px;
//    font-weight: 700;
 //   border: none;
 //   border-radius: 10px;
 //   cursor: pointer;
   // transition: all 0.8s ease-in-out;
//`

const Card = styled.div`
    width: 330px;
    height: 490px;
    background-color: ${({ theme }) => theme.card};
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0 0 12px 4px rgba(0,0,0,0.4);
    overflow: hidden;
    padding: 26px 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    transition: all 0.5s ease-in-out;
    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 0 50px 4px rgba(0,0,0,0.6);
        filter: brightness(1.1);
    }
    @media only screen and (max-width: 768px){
        padding: 10px;
        width: 300px;
        height: auto;
    }
`

const Image = styled.img`
    width: 100%;
    height: 180px;
    background-color: ${({ theme }) => theme.white};
    border-radius: 10px;
    box-shadow: 0 0 16px 2px rgba(0,0,0,0.3);
`

const Details = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0px;
    padding: 0px 2px;
`

const Title = styled.div`
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_secondary};
    overflow: hidden;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const DateStr = styled.div`
    font-size: 12px;
    margin-left: 2px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary + 80};
    @media only screen and (max-width: 768px){
        font-size: 10px;
    }
`

const Description = styled.div`
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary + 99};
    overflow: hidden;
    margin-top: 8px;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const Issuer = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-top: 4px;
    color: ${({ theme }) => theme.primary};
`

const CertificationCard = ({ certification }) => {
    return (
        <Card onClick={() => certification.link && window.open(certification.link, '_blank')}>
            <Image src={certification.image} />
            <Details>
                <Title>{certification.title}</Title>
                <Issuer>{certification.issuer}</Issuer>
                <DateStr>{certification.date}</DateStr>
                <Description>{certification.description}</Description>
            </Details>
        </Card>
    )
}

export default CertificationCard
